import React from 'react';
import './index.less';
import { ABSModal } from '../ABSModal';
import Wechat from '../../utils/wechatUtil';
import ABSSubTitle from '../ABSSubTitle';
const wechatlogo = require('../../assets/images/icon-wechat@2x.png');
// const abslinklogo = require('../../assets/images/icon-app@2x.png');
// const abslinkQrcode = require('../../assets/images/abslink-qrcode.png');

class ABSOtherLogin extends React.Component {
  wechatModal;
  abslinkModal;

  onWechatLogin = () => {
    this.wechatModal.show(true);
  };

  onAbsLinkDownload = () => {
    this.abslinkModal.show(true);
  };

  render() {
    const wechatContent = (
      <div className="modal-otherway">
        <ABSSubTitle title="微信登录" className="modal-otherway-title" />
        <iframe
          className="modal-otherway-iframe"
          frameBorder="0"
          sandbox="allow-scripts allow-same-origin allow-top-navigation"
          scrolling="no"
          src={Wechat.getExternalURL()}
        />
      </div>
    );

    // const absLinkContent = (
    //   <div className="modal-otherway">
    //     <ABSSubTitle title="CNABS小程序" className="modal-otherway-title" />
    //     <img src={abslinkQrcode} />
    //     <div className="modal-otherway-description">手机扫描二维码登录CNABS小程序</div>
    //   </div>
    // );

    return (
      <div className="abs-login-content-otherway">
        <div className="abs-login-content-otherway-logo" onClick={this.onWechatLogin}>
          <img src={wechatlogo} />
          <span className="abs-login-content-otherway-logo-title">微信登录</span>
        </div>
        {/* CNABS小程序 */}
        {/* <div
          className="abs-login-content-otherway-logo abs-login-content-otherway-abslink"
          onClick={this.onAbsLinkDownload}
        >
          <img src={abslinklogo} />
          <span className="abs-login-content-otherway-logo-title">CNABS小程序</span>
        </div> */}

        <ABSModal
          content={wechatContent}
          width={420}
          footer={null}
          ref={view => (this.wechatModal = view)}
          wrapClassName="wechat-modal"
        />
        {/* <ABSModal
          content={absLinkContent}
          width={420}
          footer={null}
          ref={view => (this.abslinkModal = view)}
          wrapClassName="abslink-modal"
        /> */}
      </div>
    );
  }
}

export default ABSOtherLogin;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSOtherLogin/index.tsx